"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInsightContext = exports.InsightsProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const createQueue_1 = require("./createQueue");
function InsightsProvider({ children, developerQueries = false, backendUrl = null, }) {
    const value = react_1.useMemo(() => ({ developerQueries, rateLimitQueue: createQueue_1.createQueue(2), backendUrl }), [
        developerQueries,
        backendUrl,
    ]);
    return jsx_runtime_1.jsx(InsightsContext.Provider, Object.assign({ value: value }, { children: children }), void 0);
}
exports.InsightsProvider = InsightsProvider;
function useInsightContext() {
    const client = react_1.useContext(InsightsContext);
    if (!client) {
        throw new Error('Please wrap your insights code in an <InsightsProvider> component.');
    }
    return client;
}
exports.useInsightContext = useInsightContext;
const InsightsContext = react_1.createContext({
    rateLimitQueue: createQueue_1.createQueue(2),
    developerQueries: false,
    backendUrl: null,
});
//# sourceMappingURL=InsightsProvider.js.map